import React, { createContext } from 'react';

import { Transition } from 'history';

interface NavigationBlockerContextType {
  setNavPromptShown: React.Dispatch<React.SetStateAction<boolean>>;
  navPromptShown: boolean;
  confirmNavigation: () => void;
  cancelNavigation: () => void;
  setBlockedTransition: (transition: Transition) => void;
}

export const NavigationBlockerContext = createContext<NavigationBlockerContextType>(
  {} as NavigationBlockerContextType
);
